export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9346.5250ce09.jpg";